<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',

}
</script>

<style lang="scss">
#app {
  width: 100%;
  min-height: 100%;
}
.wrap{
  width: 1600px;
  margin:0 auto;
  min-width: 1200px;
}
.page-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 60px 0;
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: $primaryColor;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: $primaryColor;
      color: #fff;
    }
  }
@media screen and (max-width: 1600px){
  .wrap {
      width: 1200px;
  }
}
.z-flex{
  display: flex;
  justify-content:flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.z-flex-col{
  flex-direction: column;
}
.z-flex-between{
  justify-content:space-between;
}
.z-flex-around{
  justify-content:space-around;
}
.z-flex-center{
  justify-content:center;
}
.z-flex-end{
  justify-content:flex-end;
}
 .el-dropdown-link{
    outline: none;
  }
.el-dropdown-menu__item{
  padding:0 25px;
}
.el-table .cell{
  text-align: center;
}
.el-table th{
  background:#ddd!important;
  color: #333;
}
.el-message-box--center .el-message-box__status{
    font-size:48px!important;
  }
.el-message-box .el-button,.z-dialog  .el-button{
  min-width: 100px;
}
.z-dialog .el-dialog__header{
  background:#f77e5e;
  padding:10px 20px;
  .el-dialog__title{
    color: #fff;
  }
  .el-dialog__headerbtn{
    top:14px;
    .el-dialog__close{
      color: #fff;
    }
  }
}
.z-break{
  width:1px;
  height: 16px;
  display:inline-block;
  background:#ccc;
  margin:0 10px;
  vertical-align: middle;
}
</style>
